import './DepartmentSelectionStepSkeleton.scss';

const DepartmentSelectionStepSkeleton = () => {
  return (
    <div className="department-selection-step-skeleton">
      <div className="skeleton-text skeleton-text-long"></div>
      <div className="skeleton-radio-group">
        <div className="skeleton-radio-option">
          <div className="skeleton-radio"></div>
          <div className="skeleton-label"></div>
        </div>
        <div className="skeleton-dropdown"></div>
      </div>
      <div className="skeleton-radio-group">
        <div className="skeleton-radio-option">
          <div className="skeleton-radio"></div>
          <div className="skeleton-label"></div>
        </div>
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
      </div>
    </div>
  );
};

export default DepartmentSelectionStepSkeleton;